import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtons = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 .182a3.273 3.273 0 0 0-3.273 3.273A3.273 3.273 0 0 0 10 6.728a3.273 3.273 0 0 0 3.273-3.273A3.273 3.273 0 0 0 10 .182M3.455 6.727A3.273 3.273 0 0 0 .182 10a3.273 3.273 0 0 0 3.273 3.273A3.273 3.273 0 0 0 6.728 10a3.273 3.273 0 0 0-3.273-3.273m13.09 0A3.273 3.273 0 0 0 13.274 10a3.273 3.273 0 0 0 3.271 3.273A3.273 3.273 0 0 0 19.818 10a3.273 3.273 0 0 0-3.273-3.273M10 13.273a3.273 3.273 0 0 0-3.273 3.272A3.273 3.273 0 0 0 10 19.818a3.273 3.273 0 0 0 3.274-3.273A3.273 3.273 0 0 0 10 13.273" })
});
export default SvgButtons;
